import { useMemo } from "react";
import { useQuery } from "@apollo/client";
import { LenssourceModelLensSourceType } from "../../../gql-generated/types";
import { getSupportedLensSourceTypes } from "../api/queries/getSupportedLensSourceTypes";
import {
    type GetSupportedLensSourceTypesQuery,
    type GetSupportedLensSourceTypesQueryVariables,
} from "../api/queries/getSupportedLensSourceTypes.gql-generated";
import { useParams } from "react-router-dom";

export function useLensSourceTypes() {
    const { orgId } = useParams<{ orgId?: string }>();
    const { data, loading } = useQuery<GetSupportedLensSourceTypesQuery, GetSupportedLensSourceTypesQueryVariables>(
        getSupportedLensSourceTypes,
        {
            variables: {
                organizationId: orgId ?? "",
            },
            skip: orgId === undefined,
        },
    );
    const types = useMemo(
        () => data?.getSupportedLensSourceTypes?.lensSourceTypes || [],
        [data],
    ) as LenssourceModelLensSourceType[];

    // TODO: Remove once BE has implemented the new type [CAMKIT-1356]
    const tempTypes = [...new Set([...types, LenssourceModelLensSourceType.LensSpace])];

    return {
        loading,
        types: tempTypes,
    };
}
